export const Collections = {
  tenants: "tenants",
  users: "users",
  appointments: "appointments",
  generators: "generators",
  customers: "customers",
  technicians: "technicians",
} as const;

export type Collection = keyof typeof Collections;
